import { gql } from '@apollo/client'

export const NAVIGATION_LINK_FRAGMENT = gql`
    fragment NavigationLink on ComponentAtomsNavigationLink {
        Display_Text
        Destination
    }
`

export const GET_BOTTOM_NAVIGATION = gql`
    query bottomNavigation {
        bottomNavigation(publicationState: LIVE) {
            data {
                attributes {
                    Copyrights
                    Link_Columns {
                        Heading
                        Links {
                            ...NavigationLink
                        }
                    }
                    Subscribe_Heading
                    Subscribe_Field_Placeholder
                    Subscribe_Button
                    Subscribe_Sub_Heading
                    Made_In_Canada
                    Member_Links {
                        ...NavigationLink
                    }
                }
            }
        }
    }
    ${NAVIGATION_LINK_FRAGMENT}
`
